// src/services/departmentService.ts
import { api } from './api';

export interface Department {
  _id: string;
  name: string;
  slug?: string;
  createdAt?: string;
  updatedAt?: string;
  __v?: number;
}


interface DepartmentResponse {
  message: string;
  data: Department;
  error: boolean;
}

interface DepartmentsResponse {
  message: string;
  data: {
    result: Department[];
    totalCount: number;
    currentPage: number;
    totalPages: number;
    previousPage: number | null;
    nextPage: number | null;
  };
  error: boolean;
}

export const departmentService = {
  async getAllDepartments(): Promise<Department[]> {
    const response = await api.get<DepartmentsResponse>('/department');
    return response.data.data.result; // Fixed to access the result array
  },
  
  async getDepartment(id: string): Promise<Department> {
    const response = await api.get<DepartmentResponse>(`/department/${id}`);
    return response.data.data;
  },
  
  async createDepartment(departmentData: { name: string }): Promise<Department> {
    const response = await api.post<DepartmentResponse>('/department', departmentData);
    return response.data.data;
  },
  
  async updateDepartment(id: string, departmentData: { name: string }): Promise<Department> {
    const response = await api.put<DepartmentResponse>(`/department/${id}`, departmentData);
    return response.data.data;
  },
  
  async deleteDepartment(id: string): Promise<void> {
    await api.delete(`/department/${id}`);
  }
};